export enum UserIncludeFieldType {
  USER_ID = 'USER_ID',
  STATUS = 'STATUS',
  STATUSES = 'STATUSES',
  AUDIT = 'AUDIT',
  IDP = 'IDP',
  PREVIOUS_STATUS = 'PREVIOUS_STATUS',
  CONTACT_POINT = 'CONTACT_POINT',
  OCCASION = 'OCCASION',
  HUMAN_NAME = 'HUMAN_NAME',
  LOCALIZATION = 'LOCALIZATION',
  PERSONAL = 'PERSONAL',
  TAG = 'TAG',
  PROJECT = 'PROJECT',
  ORG = 'ORG',
  PRACTICE = 'PRACTICE',
  ROLE_ACCESS_REF = 'ROLE_ACCESS_REF',
  META = 'META',
  EXTERNAL_IDS = 'EXTERNAL_IDS',
  CUSTOM_STATUSES = 'CUSTOM_STATUSES',
  PREVIOUS_CUSTOM_STATUSES = 'PREVIOUS_CUSTOM_STATUSES',
  STUDY_ECODE = 'STUDY_ECODE',
  EVENT_ID = 'EVENT_ID',
  STUDY_RANDOMIZED_TIMESTAMP = 'STUDY_RANDOMIZED_TIMESTAMP',
  STUDY_SCREENED_TIMESTAMP = 'STUDY_SCREENED_TIMESTAMP',
  STUDY_END_TIMESTAMP = 'STUDY_END_TIMESTAMP',
  PROVISIONED_DEVICE_SERIAL_NO = 'PROVISIONED_DEVICE_SERIAL_NUMBER',
  LAST_CLIENT_ACTIVITY = 'LAST_CLIENT_ACTIVITY',
}
